'use strict';

angular.module('clientDashboardApp').directive('shortLink', ['$log', function ($log) {
  return {
    restrict: 'A',
    scope: {
      text: '='
    },
    replace: true,
    link: function (scope, elem, attrs, ctrl) {

      if(!angular.isDefined(parseInt(attrs.maxLength))){
        $log.warn('Invalid maxLength! maxLength:' + attrs.maxLength);
        return;
      }
      var maxLength = parseInt(attrs.maxLength);
      var cleanedText = scope.text.trim();
      var truncate = cleanedText.length > maxLength;
      var shortLink = cleanedText.substring(0,maxLength + 1);
      var lastSpace = shortLink.lastIndexOf(" ");
      if(truncate){
        if(lastSpace > 0 && lastSpace <= maxLength){
          shortLink = shortLink.substring(0,lastSpace);
        }else{
          shortLink = shortLink.substring(0, maxLength);
        }
      }
      var expandable;
      if(!angular.isDefined(attrs.expandable)) {
        expandable = true;
      }else{
        expandable = attrs.expandable;
      }

      if(truncate){
        shortLink += "...";
        scope.hasMore = expandable;
      }
      scope.shortLink = shortLink;
      elem.text(shortLink);

    }
  }
}]);
